import { Inject } from 'inversify-props'
import { Page, ProdutoMarketplace } from '@/models'
import { AxiosRequestConfig } from 'axios'
import type { MarketplaceServiceAdapter } from './adapter'

export class FindProdutoMarketplaceUseCase {
	@Inject('MarketplaceServiceAdapter')
	private marketplaceAdapter!: MarketplaceServiceAdapter

	get = async (produtoId: string): Promise<ProdutoMarketplace> =>
		this.marketplaceAdapter.getProduto(produtoId)

	findAll = async (lojaId: string, params: any, config?: AxiosRequestConfig): Promise<Page<ProdutoMarketplace>> =>
		this.marketplaceAdapter.findAll(lojaId, params, config)

	validaProdutoExistente = async (produtoId: string, lojaId: string): Promise<boolean> =>
		this.marketplaceAdapter.validaProdutoExistente(produtoId, lojaId)
}